export default "__VITE_ASSET__BOI_cf2P__"